// region: web https://github.com/mrousavy/react-native-mmkv/blob/main/packages/react-native-mmkv/src/web/getLocalStorage.ts
const canUseDOM =
  typeof window !== 'undefined' && window.document?.createElement != null;

const hasAccessToLocalStorage = () => {
  try {
    // throws ACCESS_DENIED error
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    window.localStorage;

    return true;
  } catch {
    return false;
  }
};
const inMemoryStorage = new Map<string, string>();

function getLocalStorage(): Storage {
  if (!canUseDOM) {
    throw new Error(
      'Tried to access storage on the server. Did you forget to call this in useEffect?',
    );
  }

  if (!hasAccessToLocalStorage()) {
    return {
      getItem: (key: string) => inMemoryStorage.get(key) ?? null,
      setItem: (key: string, value: string) => inMemoryStorage.set(key, value),
      removeItem: (key: string) => inMemoryStorage.delete(key),
      clear: () => inMemoryStorage.clear(),
      length: inMemoryStorage.size,
      key: (index: number) => Object.keys(inMemoryStorage).at(index) ?? null,
    } as Storage;
  }

  const domStorage =
    global?.localStorage ?? window?.localStorage ?? localStorage;
  if (domStorage == null) {
    throw new Error(`Could not find 'localStorage' instance!`);
  }
  return domStorage;
}
// endregion: web

class LocalStorageBridge {
  async getInt(key: string): Promise<number | null> {
    const value = getLocalStorage().getItem(key);
    if (value == null) return null;
    return Number(value);
  }
  async getDouble(key: string): Promise<number | null> {
    const value = getLocalStorage().getItem(key);
    if (value == null) return null;
    return Number(value);
  }
  async getBoolean(key: string) {
    const value = getLocalStorage().getItem(key);
    if (value == null) return null;
    return Number(value);
  }
  async getString(key: string) {
    return getLocalStorage().getItem(key);
  }

  putBoolean(key: string, value: boolean) {
    getLocalStorage().setItem(key, value.toString());
  }
  putString(key: string, value: string) {
    getLocalStorage().setItem(key, value);
  }
  putInt(key: string, value: number) {
    getLocalStorage().setItem(key, value.toString());
  }
  putDouble(key: string, value: number) {
    getLocalStorage().setItem(key, value.toString());
  }
}

export const localStorageBridge = new LocalStorageBridge();
